export default "__VITE_PUBLIC_ASSET__7531bd5b__"